import { render, staticRenderFns } from "./OrderIssueView.vue?vue&type=template&id=022d68dc&scoped=true&"
import script from "./OrderIssueView.vue?vue&type=script&lang=js&"
export * from "./OrderIssueView.vue?vue&type=script&lang=js&"
import style0 from "./OrderIssueView.vue?vue&type=style&index=0&id=022d68dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d68dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAppBar,VBtn,VIcon,VLayout,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VTextarea})
